export default __webpack_public_path__ + "static/media/profileSidebarIcon_test.f35d3548.svg";